import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _Loader;
import { lazy, Suspense, useEffect, useState } from "react";
import { useTranslation } from "@crehana/i18n";
import { useStickyState } from "@crehana/react-hooks";
import { Loader } from "@crehana/ui";
import ClientSideComponent from "../ClientSideComponent";
import localeEs from "./i18n/localeEs";
import localePt from "./i18n/localePt";
import { CALL_CENTER_DIALOG_PAGE_KEY } from "./constants";
import { jsx as _jsx } from "react/jsx-runtime";
var TRANSLATIONS = {
  es: /*#__PURE__*/_defineProperty({}, CALL_CENTER_DIALOG_PAGE_KEY, localeEs.es),
  pt: /*#__PURE__*/_defineProperty({}, CALL_CENTER_DIALOG_PAGE_KEY, localePt.pt)
};
var timer;
var LANDING_USER_ARRIVALS_REQUIRED_TO_TRIGGER = 2;
var LazyCallCenterDialog = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "MembershipPage-CallCenterDialog" */"./CallCenterDialog");
});
var CallCenterDialogLazy = function CallCenterDialogLazy(_ref) {
  var _ref$secondsToTrigger = _ref.secondsToTrigger,
    secondsToTrigger = _ref$secondsToTrigger === void 0 ? 0 : _ref$secondsToTrigger,
    _ref$identifier = _ref.identifier,
    identifier = _ref$identifier === void 0 ? 'generic-dialog' : _ref$identifier,
    _ref$configuration = _ref.configuration,
    configuration = _ref$configuration === void 0 ? 'all' : _ref$configuration,
    trackingSource = _ref.trackingSource,
    originUrl = _ref.originUrl,
    dialogSource = _ref.dialogSource,
    source = _ref.source;
  var _useTranslation = useTranslation(),
    addResourceBundle = _useTranslation.addResourceBundle;
  addResourceBundle(TRANSLATIONS);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    evaluatingConfiguration = _useState4[0],
    setEvaluatingConfiguration = _useState4[1];
  var dialogIdentifier = identifier;
  var _useStickyState = useStickyState(0, "PAGE_VISIT_COUNTER_".concat(dialogIdentifier)),
    _useStickyState2 = _slicedToArray(_useStickyState, 2),
    pageVisitCounter = _useStickyState2[0],
    setPageVisitCounter = _useStickyState2[1];

  // This store if the user has previously closed the dialog by any reason
  var _useStickyState3 = useStickyState(false, "closedByTime_".concat(dialogIdentifier)),
    _useStickyState4 = _slicedToArray(_useStickyState3, 2),
    closedByTime = _useStickyState4[0],
    setClosedByTime = _useStickyState4[1];
  var _useStickyState5 = useStickyState(false, "closedByVisit_".concat(dialogIdentifier)),
    _useStickyState6 = _slicedToArray(_useStickyState5, 2),
    closedByVisit = _useStickyState6[0],
    setClosedByVisit = _useStickyState6[1];
  var startTriggerByTime = function startTriggerByTime() {
    setEvaluatingConfiguration('time');
    timer = setTimeout(function () {
      setIsOpen(true);
    }, secondsToTrigger * 1000);
  };
  var startTriggerByVisit = function startTriggerByVisit() {
    setEvaluatingConfiguration('visit');
    // We are using a +1 hack 'cause the pageVisitCounter doesn't include the current visit
    if (pageVisitCounter + 1 === LANDING_USER_ARRIVALS_REQUIRED_TO_TRIGGER) {
      setIsOpen(true);
    } else {
      // Increase the page visit counter
      setPageVisitCounter(pageVisitCounter + 1);
    }
  };
  useEffect(function () {
    if (configuration === 'only-timer' && !closedByTime) {
      startTriggerByTime();
    } else if (configuration === 'all') {
      if (!closedByTime) {
        startTriggerByTime();
      } else if (!closedByVisit) {
        startTriggerByVisit();
      }
    }
    return function () {
      if (timer) {
        window.clearTimeout(timer);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/_jsx(ClientSideComponent, {
    children: /*#__PURE__*/_jsx(Suspense, {
      fallback: _Loader || (_Loader = /*#__PURE__*/_jsx(Loader, {
        size: 36
      })),
      children: /*#__PURE__*/_jsx(LazyCallCenterDialog, {
        isOpen: isOpen,
        closeDialog: function closeDialog() {
          setIsOpen(false);

          // Set closedBy
          if (evaluatingConfiguration === 'time') {
            setClosedByTime(true);
          } else {
            setClosedByVisit(true);
          }
        },
        trackingSource: trackingSource,
        originUrl: originUrl,
        dialogSource: dialogSource,
        source: source
      })
    })
  });
};
export { CallCenterDialogLazy as CallCenterDialog };
export default CallCenterDialogLazy;